export const getDiscoverAppsQueryBody = (discoveryParam, sorParam) => {
  const baseQuery = 'q=*&facet=true&json.nl=map&start=0&sort=sr_sv_publishedOn_dt%20desc&fl=id%2Curl%2Csr_mv_features_ss%2Csr_mv_recommendationSOR_ss%2Csr_sv_visibleOnMarketplace_b%2Csr_sv_name_s%2Csr_mv_partners_ss%2Csr_sv_appurl_s%2Csr_sv_iconUrl_s%2Csr_sv_description_t%2Csr_sv_absoluteRating_d%2Csr_sv_numRatings_l%2Csr_mv_industry_ss%2Csr_mv_solutions_ss%2Cattr_uuid_%2Csr_mv_rating_ss%2Csr_mv_features_ss%2Cribbon_s%2Cribbon_t%2Csr_sv_freeTrialOrEditionPresent_b%2Csr_sv_free_b%2Csr_sv_highestPercentageDiscount_l%2Csr_sv_href_s&rows=15';

  let query = `${baseQuery}&fq={!tag=di}dv_mv_discover_apps_ss:("${discoveryParam}")&facet=true&facet.field={!ex=di}dv_mv_discover_apps_ss`;

  if (sorParam) {
    const encodedPlatform = encodeURIComponent(sorParam).replace(/%20/g, '+');
    query += `&fq={!tag=pl}dv_mv_platforms_ss:("${encodedPlatform}")&facet.field={!ex=pl}dv_mv_platforms_ss`;
  }

  return { query };
};
